const calculateEyebrowPadding = (titleSize, eybrowSize) => {
    const specialLargeCase = eybrowSize === 'bodyLarge' ? '3x' : '4x';
    const sizeList = {
        bodySmall: '1x',
        bodyMedium: '1x',
        bodyLarge: '1x',
        title2XSmall: '2x',
        titleXSmall: '2x',
        titleSmall: '2x',
        titleMedium: '3x',
        titleLarge: '3x',
        titleXLarge: '3x',
        title2XLarge: specialLargeCase,
        featureSmall: specialLargeCase,
        featureMedium: specialLargeCase,
    };
    return titleSize && sizeList[titleSize];
};

export { calculateEyebrowPadding };
